import { store, loading, computed, action } from '~/common/mobx.decorator'
import { CollectionCursorStore } from '../collection.cursor.store'
import { mappingSkillName } from '~/common/helpers/mapping.helper'
import { omit } from 'lodash'
import { GET_SUGGESTION_JOBS_QUERY } from '~/common/apollo'

@store()
class MatchesJobStore extends CollectionCursorStore {
	constructor() {
		super(GET_SUGGESTION_JOBS_QUERY, 'suggestionJobs', ['totalCount'])
		this.name = 'availableJobStore'
	}

	@loading
	@action
	fetchData = (isReload, filterCondition, paging = {}, sortBy = { field: 'NEWEST', order: 'desc' }) => {
		const dataFilter = mappingSkillName(filterCondition)

		this.setSortBy(sortBy)

		return this.load(isReload, {
			filter: {
				...omit(dataFilter, ['locationStates', 'locationCities']),
			},
			...paging,
		})
	}

	@computed
	get totalCount() {
		return this.pageInfo.totalCount
	}
}

const matchesJobStore = new MatchesJobStore()
export { matchesJobStore, MatchesJobStore }
